<template>
  <div class="">
    <div class="container pt-3 m-auto text-left ">
       
      <form autocomplete="off" class="form-horizontal" @submit.prevent="validateBeforeSubmit">

        
        <b-row>
          <b-col cols="12">
            <b-form-group id="input-titulo" label="Titulo:" label-for="titulo"> <!--description="We'll never share your email with anyone else."-->
              <b-form-input id="titulo" type="text" v-model="logro.titulo"></b-form-input>
            </b-form-group>
            <b-form-group id="input-porcentaje" label="Porcentaje:" label-for="porcentaje" description="Introduzca valores entre 1 y 100.">
              <b-form-input step="0.01" min="0" max="100" id="porcentaje" type="number" v-model="logro.porcentaje"></b-form-input>
            </b-form-group>

          </b-col>
        </b-row>

        <b-row class="mb-3 mt-2">
          <b-col cols="6">
            <button class="btn btn-block btn-secondary" type="button" @click="cerrar">Cerrar</button>
          </b-col>
          <b-col cols="6">
            <button class="btn btn-block btn-success" type="submit">Guardar</button>
          </b-col>
        </b-row>
      </form>
      
    </div>
  </div>
  
</template>


<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'LogroEditar',
    components: {
      
    },
    props:{
      logro:Object
    },
    data () {
      return {
          curso_id : null,
      }
    },
    mounted () {
      this.curso_id = this.$route.params.curso_id;
    },
    
    methods:{
        ...mapActions({
            editar: 'cursos_logros/editar',
            setWarning: 'setWarning',
        }),
      ...mapMutations({
        
      }),
      
      validateBeforeSubmit () {
        this.$validator.validateAll().then(result => {
          console.log('validateBeforeSubmit')
          if ( ! result) {
            console.log('validateBeforeSubmit error')
            //hay errores
          } else {
            console.log('validateBeforeSubmit no error')
            this.logro.curso_id = this.$route.params.curso_id;
            
            this.editar(this.logro).then(result =>{
                this.setWarning('Logro actualizado', { root: true }).then(()=>{
                  this.$emit("actualizar")
                  this.cerrar();
              })
            }).catch(error=>{
              //todo probar si se puede quitar
              console.error("Logro error result:", error)
            })
          }
        })
      },
      cerrar() {
        this.$emit("cerrar")
      }

    },
    computed:{
      ...mapState({
        detalle: state => state.temas.detalle, 
        warning: state => state.warning,
      }),
      logroVacio(){
        return {
          curso_id : null,
          titulo : null,
          porcentaje : 0
        }
      },
      
      
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>
